import { render } from "./index.vue?vue&type=template&id=cdd2c43c&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=cdd2c43c&scoped=true&lang=css"

import exportComponent from "D:\\waibao\\lsjy-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdd2c43c"]])

export default __exports__